import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCameraOff: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-off"><path d="M9.99833 11.5L14 15.5017M14.0017 11.5L10 15.5017M7.5 6.75H2.75V20.25H21.25V6.75H16.5L14.5 3.75H9.5L7.5 6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCameraOff;
